import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { scopeNodeIdsAtom, selectedNodeIdAtom } from './state';

/**
 * Legacy/deep-link entry point for /catalog/system/:nodeId. The System view itself now renders
 * embedded in CatalogPage's own content pane (same frame the product grid otherwise occupies),
 * so the category tree sidebar stays visible instead of navigating to a separate page (see chat:
 * "Kann man das System so einbetten, dass es im Content erscheint und links die Navigation
 * erhalten bleibt?"). This route only exists so old bookmarks/links still land on the right
 * system - it just selects the node and hands off to CatalogPage.
 */
export const SystemDetailPage = () => {
    const { nodeId } = useParams();
    const setSelectedNodeId = useSetAtom(selectedNodeIdAtom);
    const setScopeNodeIds = useSetAtom(scopeNodeIdsAtom);
    const navigate = useNavigate();

    useEffect(() => {
        setSelectedNodeId(nodeId);
        // A fresh entry - a landing-page multi-select scope from an earlier visit would otherwise
        // hide this very node in the tree and cut its documents (see state.scopeNodeIdsAtom).
        setScopeNodeIds([]);
        navigate('/catalog', { replace: true });
    }, [nodeId, setSelectedNodeId, setScopeNodeIds, navigate]);

    return null;
};
